import { CheckCircle } from 'lucide-react';
import { useEffect, useState } from 'react';

import { Button } from '@/components/ui/button';
import { Dialog, DialogBody, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Textarea } from '@/components/ui/textarea';

/**
 * Props for the AnswerExplanationDialog component.
 * @property open - Controls dialog visibility.
 * @property onOpenChange - Callback for dialog open state changes.
 * @property onRemoveExplanation - Callback to remove the explanation.
 * @property value - Current explanation value.
 * @property onValueChange - Callback for explanation value changes.
 */
interface AnswerExplanationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onRemoveExplanation: () => void;
  value?: string;
  onValueChange: (value?: string) => void;
}

export function AnswerExplanationDialog(answerExplanationDialogProps: AnswerExplanationDialogProps) {
  const { open, onOpenChange, onRemoveExplanation, value: defaultValue, onValueChange } = answerExplanationDialogProps;

  const [value, setValue] = useState<string | undefined>(defaultValue);

  useEffect(() => {
    if (open) {
      setValue(defaultValue);
    }
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <DialogBody>
          <DialogHeader className="flex-col">
            <DialogTitle>Wyjaśnienie</DialogTitle>
            <DialogDescription>Dodaj wyjaśnienie, które będzie wyświetlane po udzieleniu odpowiedzi</DialogDescription>
          </DialogHeader>
          <div className="p-3">
            <Textarea value={value || ''} onChange={(e) => setValue(e.target.value || undefined)} placeholder="Wprowadź wyjaśnienie..." className="min-h-35" />
          </div>
        </DialogBody>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => {
              onRemoveExplanation();
              setValue(undefined);
              onOpenChange(false);
            }}
          >
            Usuń
          </Button>
          <Button
            onClick={() => {
              onValueChange(value);
              onOpenChange(false);
              setValue(undefined);
            }}
          >
            Zapisz <CheckCircle />
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
